import { Component, Input, forwardRef, OnInit } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { CheckboxOptionModel } from '../../../../Forms/models/checkbox-option.model';
import { ColorCheckboxesFieldModel } from '../../../models/color-checkboxes-field.model';

// frequently, collections of checkbox options come with an associated color which you can pick
// this component does that job by putting a color swatch below every checkbox
@Component({
    selector: 'agpr-color-checkboxes-field',
    templateUrl: './color-checkboxes-field.component.html',
    styleUrls: ['./color-checkboxes-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ColorCheckboxesFieldComponent)
        }
    ],
    standalone: false
})
export class ColorCheckboxesFieldComponent extends AbstractFormFieldComponent implements OnInit {
    @Input() declare field: ColorCheckboxesFieldModel;

    valueMap: { [key: string]: boolean } = {};
    filteredOptions: CheckboxOptionModel[] = [];

    ngOnInit() {
        if (!this.block.displayElement.styles.colorMap) {
            this.block.displayElement.styles.colorMap = {};
        }

        this.field.options.forEach(option => {
            if (!this.block.displayElement.styles.colorMap[option.key]) {
                this.block.displayElement.styles.colorMap[option.key] = option.defaultColor;
            }
        });

        this.handleChanges();
    }

    handleChanges(event?: any): void {
        this.valueMap = {};
        const colorMap = this.block.displayElement.styles.colorMap;

        if (!this.value) {
            this.value = [];
        }

        // build an object that lets us see what checkboxes are enabled in the template
        (<[]>this.value).forEach(value => {
            this.valueMap[value] = true;

            // if we're missing a color from the color map (happens when disabling then re-enabling)
            // set the default
            if (!colorMap[value]) {
                colorMap[value] = this.field.options.find(option => option.key === value).defaultColor;
            }
        });

        this.changes.emit(event || this.value);
    }

    // |key| should usually be an id/enum value identifying the appropriate element
    handleColorChange(colorHexString: string, key: string): void {
        this.block.displayElement.styles.colorMap[key] = colorHexString;
        this.handleChanges();
    }
}
